import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCompletedRequests } from '../../../hooks';
import { searchMultiFields } from '../../../utils';

import { Accordion, AccordionItem, AccordionTrigger, AccordionContent, Badge } from '@pella/sash-framework';
import { RequestCards } from '../RequestCards/RequestCards';
import { QueueCards } from '../QueueCards/QueueCards';
import { ThreeDots } from 'react-loader-spinner';

import * as classes from './StatusAccordion.module.css';

/**
 * Accordion molecule
 * @param {Local.StatusAccordionProps} props - Component props
 */
export const StatusAccordion = ({
  requests = [],
  queues = [],
  searchValue = '',
  id,
  label,
  className,
  badgeClass,
  animation,
}) => {
  const { pathname } = useLocation();

  const [completedAccordionOpen, setCompletedAccordionOpen] = useState(false);

  const { data: completedRequests, isLoading } = useCompletedRequests(
    pathname === '/worklist' ? 'resource' : 'location',
    completedAccordionOpen,
  );

  /**
   * Handles accordion toggle event for completed requests
   */
  const handleToggle = () => {
    if (id === 'wl-completed') setCompletedAccordionOpen((prev) => !prev);
  };

  const requestData =
    id === 'wl-completed' ? searchMultiFields(searchValue, completedRequests?.completed) || [] : requests;
  const showNoHistory = id === 'wl-completed' && !isLoading && !requestData.length;

  return (
    <Accordion data-testid={`status-accordion-${id}`} className={classes[animation]} variant='box'>
      <AccordionItem className={classes[className]}>
        <AccordionTrigger onClick={handleToggle}>
          <div className={classes.header}>
            <p>{label}</p>
            {badgeClass && <Badge className={classes[badgeClass]}>{requestData.length || queues.length}</Badge>}
          </div>
        </AccordionTrigger>
        <AccordionContent>
          {id === 'wl-completed' && isLoading && (
            <div data-testid='loading' className={classes.loading}>
              <ThreeDots color='black' width='50' />
            </div>
          )}
          {requestData.length > 0 && <RequestCards data={requestData} />}
          {showNoHistory && <div className={classes.noHistory}>No History Available.</div>}
          {queues.length > 0 && <QueueCards data={queues} />}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
